export const SAAS_ONLY_FEATURE_TOOL_TIP = 'Available in Enterprise Version';
export const RESTRICT_OVERRIDES_FROM_UI_TOOLTIP =
  'Changes are restricted. Edit from Git.';
export const RESTRICT_OVERRIDES_FROM_UI_ONGOING_MIGRATION_TOOLTIP =
  'Changes are restricted because migration is in progress.';
export const BLOCK_RELEASES_ON_MAINTENANCE_RELEASE_FAIL_TOOLTIP =
  'Maintenance release has failed. All other releases have been paused until this is fixed.';
